import {
  GET_DATA_CUT_SURVEYS_ERROR,
  GET_DATA_CUT_SURVEYS_START,
  GET_DATA_CUT_SURVEYS_SUCCESS,
  SEND_DATA_CUT_SUBMISSION_EMAIL_FAILED,
  SEND_DATA_CUT_SUBMISSION_EMAIL_START,
  SEND_DATA_CUT_SUBMISSION_EMAIL_SUCCESS,
  RESET_DATA_CUT_ERRORS,
  UPDATE_EXCEPTION_DECISION_ERROR,
  UPDATE_EXCEPTION_DECISION_START,
  UPDATE_EXCEPTION_DECISION_SUCCESS,
  RESET_EXCEPTION_DECISION_SUCCESS,
  GET_MIGRATION_DETAILS_START,
  GET_MIGRATION_DETAILS_SUCCESS,
  GET_MIGRATION_DETAILS_ERROR,
  GET_DATA_CUT_DROPDOWN_SUCCESS,
  GET_DATA_CUT_DROPDOWN_ERROR,
  SET_FILTER_DROPDOWN,
  SET_LANDING_SEARCH
} from '../actions/DataCutMigrationActions';

const initialState = {
  dataCutSurveys: [],
  exceptionOnlySurveys: [],
  noExceptionSurveys: [],
  dataCutSurveysLoading: false,
  dataCutSurveysError: false,
  isSendingSubmissionEmail: false,
  dataCutExceptionsSuccess: false,
  dataCutExceptionsSubmitting: false,
  dataCutsSubmitted: false,
  dataCuts: [],
  dataCutOptions: [],
  dataCutsSuccess: false,
  dataCutsError: false,
  dataCutsLoading: false,
  dataCutsOptionsError: false,
  totalCount: 0,
  totalDataCutOnlyExceptions: 0,
  totalDataCutsWithDataCutOnlyExceptions: 0,
  dropdownFilter: '',
  migrationLandingSearch: ''
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_DATA_CUT_SURVEYS_START: {
      return {
        ...state,
        dataCutSurveysLoading: true
      };
    }
    case GET_DATA_CUT_SURVEYS_SUCCESS: {
      return {
        ...state,
        dataCutSurveysError: false,
        dataCutSurveysLoading: false,
        dataCutSurveys: action.dataCutSurveys,
        exceptionOnlySurveys: action.exceptionOnlySurveys,
        noExceptionSurveys: action.noExceptionSurveys,
        totalCount: action.totalCount,
        totalDataCutsWithDataCutOnlyExceptions: action.totalDataCutsWithDataCutOnlyExceptions,
        totalDataCutOnlyExceptions: action.totalDataCutOnlyExceptions
      };
    }
    case GET_DATA_CUT_SURVEYS_ERROR: {
      return {
        ...state,
        dataCutSurveysError: true,
        dataCutSurveysLoading: false
      };
    }
    case SEND_DATA_CUT_SUBMISSION_EMAIL_START: {
      return {
        ...state,
        isSendingSubmissionEmail: true,
        dataCutSurveysError: false,
        dataCutExceptionsError: false,
        dataCutSurveysLoading: false
      };
    }
    case UPDATE_EXCEPTION_DECISION_START: {
      return {
        ...state,
        dataCutExceptionsSubmitting: true
      };
    }
    case UPDATE_EXCEPTION_DECISION_SUCCESS: {
      return {
        ...state,
        dataCutExceptionsSuccess: true,
        dataCutExceptionsError: false,
        dataCutsSubmitted: false
      };
    }
    case SEND_DATA_CUT_SUBMISSION_EMAIL_SUCCESS: {
      return {
        ...state,
        isSendingSubmissionEmail: false
      };
    }
    case SEND_DATA_CUT_SUBMISSION_EMAIL_FAILED: {
      return {
        ...state,
        isSendingSubmissionEmail: false,
        dataCutExceptionsError: true,
        dataCutExceptionsSuccess: false,
        dataCutsSubmitted: false
      };
    }
    case GET_MIGRATION_DETAILS_START: {
      return {
        ...state,
        dataCutsLoading: true,
        dataCutsError: false,
        dataCutsSuccess: false
      };
    }
    case GET_MIGRATION_DETAILS_SUCCESS: {
      return {
        ...state,
        dataCuts: action.migrationDetails,
        dataCutsLoading: false,
        dataCutsSuccess: true,
        dataCutsError: false
      };
    }
    case GET_MIGRATION_DETAILS_ERROR: {
      return {
        ...state,
        dataCutsError: true,
        dataCutsSuccess: false,
        dataCutsLoading: false
      };
    }
    case GET_DATA_CUT_DROPDOWN_SUCCESS: {
      return {
        ...state,
        dataCutOptions: action.dataCutOptions,
        dataCutOptionsError: false
      };
    }
    case SET_FILTER_DROPDOWN: {
      return {
        ...state,
        dropdownFilter: action.dropdownFilter
      };
    }
    case SET_LANDING_SEARCH: {
      return {
        ...state,
        migrationLandingSearch: action.migrationLandingSearch
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
}
